/* eslint-disable */
/* prettier-ignore */

/**
 * Do not edit directly, this file was auto-generated.
 */

export const tokens = {
  core: {
    opacities: {
      'opacity-0': 0,
      'opacity-10': 10,
      'opacity-20': 20,
      'opacity-30': 30,
      'opacity-40': 40,
      'opacity-50': 50,
      'opacity-60': 60,
      'opacity-70': 70,
      'opacity-80': 80,
      'opacity-90': 90,
      'opacity-100': 100,
    },
    colors: {
      'blue-spark': {
        '100': '#e0eaff',
        '200': '#c5d8ff',
        '300': '#a1bdff',
        '400': '#7ca2fa',
        '500': '#1f64ff',
        '600': '#004eff',
        '700': '#003bc0',
        '800': '#022c8b',
        '900': '#001e60',
        '1000': '#001137',
      },
      'sea-sight': {
        '100': '#d9f6ff',
        '200': '#b1ecff',
        '300': '#55d5ff',
        '400': '#00b8f4',
        '500': '#009ccf',
        '600': '#0080aa',
        '700': '#006687',
        '800': '#004d66',
        '900': '#003546',
        '1000': '#001f29',
      },
      macquarie: {
        '100': '#d9f6f7',
        '200': '#b2edf0',
        '300': '#58d8de',
        '400': '#00bec5',
        '500': '#00a1a7',
        '600': '#00848a',
        '700': '#00696d',
        '800': '#004f52',
        '900': '#003739',
        '1000': '#002021',
      },
      'generic-viridian': {
        '100': '#d8f7f0',
        '200': '#afefe1',
        '300': '#51dcbd',
        '400': '#00c296',
        '500': '#00a47f',
        '600': '#008769',
        '700': '#006b53',
        '800': '#00513f',
        '900': '#00382b',
        '1000': '#002019',
      },
      'green-bell-pepper': {
        '100': '#e1f7d8',
        '200': '#c1efb0',
        '300': '#7cdd56',
        '400': '#37c500',
        '500': '#2fa700',
        '600': '#268900',
        '700': '#1e6d00',
        '800': '#175200',
        '900': '#103900',
        '1000': '#092100',
      },
      'sizzling-sunrise': {
        '100': '#fff2a5',
        '200': '#ffe336',
        '300': '#eac300',
        '400': '#d0a600',
        '500': '#bd8a00',
        '600': '#9d6e00',
        '700': '#7d5800',
        '800': '#624000',
        '900': '#432c00',
        '1000': '#271900',
      },
      'golden-stone': {
        '100': '#fff7e3',
        '200': '#fee8b3',
        '300': '#ffd275',
        '400': '#ffbd35',
        '500': '#d79203',
        '600': '#9d5502',
        '700': '#8a4900',
        '800': '#663600',
        '900': '#472600',
        '1000': '#291500',
      },
      'lucky-orange': {
        '100': '#ffeedf',
        '200': '#ffdcbe',
        '300': '#ffb77a',
        '400': '#ff8e2c',
        '500': '#e96c00',
        '600': '#c25400',
        '700': '#9e3f00',
        '800': '#7c2e00',
        '900': '#571d00',
        '1000': '#331100',
      },
      'electric-crimson': {
        '100': '#fff4f8',
        '200': '#ffe9f6',
        '300': '#ffc5ed',
        '400': '#ff89b4',
        '500': '#ff559c',
        '600': '#e930a6',
        '700': '#bc207e',
        '800': '#880057',
        '900': '#6c003a',
        '1000': '#31000b',
      },
      'electric-indigo': {
        '100': '#f2e9ff',
        '200': '#e3d1ff',
        '300': '#ccacfe',
        '400': '#c098ff',
        '500': '#aa74ff',
        '600': '#914cff',
        '700': '#7016ff',
        '800': '#5e00f2',
        '900': '#390093',
        '1000': '#23005b',
      },
      obsidian: {
        '100': '#f9f9f9',
        '200': '#e7ecee',
        '300': '#c6ced2',
        '400': '#a0adb4',
        '500': '#83939c',
        '600': '#667a85',
        '700': '#4e616b',
        '800': '#3a4951',
        '900': '#283237',
        '1000': '#171c1f',
      },
      'blue-sari': {
        '100': '#f7fafe',
        '200': '#e1e5ea',
        '300': '#c2c7cf',
        '400': '#a5abb8',
        '500': '#8891a2',
        '600': '#6d778c',
        '700': '#545f74',
        '800': '#3f4757',
        '900': '#2b313b',
        '1000': '#181c22',
      },
      'purple-sea': {
        '100': '#f8f9ff',
        '200': '#eef0fb',
        '300': '#e0dff1',
        '400': '#b4b2d0',
        '500': '#8d89b5',
        '600': '#716e98',
        '700': '#50517d',
        '800': '#262755',
        '900': '#1a153b',
        '1000': '#040229',
        '20-alpha': 'rgba(119, 122, 247, 0.3)',
      },
      'trail-print': {
        '100': '#f2f2f2',
        '200': '#e3e2e2',
        '300': '#c8c6c5',
        '400': '#adaba9',
        '500': '#94908e',
        '600': '#7b7673',
        '700': '#625d5b',
        '800': '#494644',
        '900': '#32302e',
        '1000': '#1d1b1a',
      },
      white: {
        '0': 'rgba(255, 255, 255, 0)',
        '3': 'rgba(255, 255, 255, 0.03)',
        '5': 'rgba(255, 255, 255, 0.05)',
        '10': 'rgba(255, 255, 255, 0.1)',
        '20': 'rgba(255, 255, 255, 0.2)',
        '30': 'rgba(255, 255, 255, 0.3)',
        '40': 'rgba(255, 255, 255, 0.4)',
        '50': 'rgba(255, 255, 255, 0.5)',
        '60': 'rgba(255, 255, 255, 0.6)',
        '70': 'rgba(255, 255, 255, 0.7)',
        '80': 'rgba(255, 255, 255, 0.8)',
        '90': 'rgba(255, 255, 255, 0.9)',
        '100': '#ffffff',
      },
      black: {
        '0': 'rgba(0, 0, 0, 0)',
        '3': 'rgba(0, 0, 0, 0.03)',
        '5': 'rgba(0, 0, 0, 0.05)',
        '10': 'rgba(0, 0, 0, 0.1)',
        '20': 'rgba(0, 0, 0, 0.2)',
        '30': 'rgba(0, 0, 0, 0.3)',
        '40': 'rgba(0, 0, 0, 0.4)',
        '50': 'rgba(0, 0, 0, 0.5)',
        '60': 'rgba(0, 0, 0, 0.6)',
        '70': 'rgba(0, 0, 0, 0.7)',
        '80': 'rgba(0, 0, 0, 0.8)',
        '90': 'rgba(0, 0, 0, 0.9)',
        '100': '#000000',
      },
      brand: {
        primary: {
          '100': '#e0eaff',
          '200': '#c5d8ff',
          '300': '#a1bdff',
          '400': '#7ca2fa',
          '500': '#1f64ff',
          '600': '#004eff',
          '700': '#003bc0',
          '800': '#022c8b',
          '900': '#001e60',
          '1000': '#001137',
        },
        success: {
          '100': '#e1f7d8',
          '200': '#c1efb0',
          '300': '#7cdd56',
          '400': '#37c500',
          '500': '#2fa700',
          '600': '#268900',
          '700': '#1e6d00',
          '800': '#175200',
          '900': '#103900',
          '1000': '#092100',
        },
        warning: {
          '100': '#fff7e3',
          '200': '#fee8b3',
          '300': '#ffd275',
          '400': '#ff8e2c',
          '500': '#e96c00',
          '600': '#c25400',
          '700': '#9e3f00',
          '800': '#7c2e00',
          '900': '#571d00',
          '1000': '#331100',
        },
        danger: {
          '100': '#fff4f8',
          '200': '#ffe9f6',
          '300': '#ffc5ed',
          '400': '#ff89b4',
          '500': '#ff559c',
          '600': '#e930a6',
          '700': '#bc207e',
          '800': '#880057',
          '900': '#6c003a',
          '1000': '#31000b',
        },
        'primary-alpha': {
          '0': 'rgba(31, 100, 255, 0)',
          '3': 'rgba(31, 100, 255, 0.03)',
          '5': 'rgba(31, 100, 255, 0.05)',
          '10': 'rgba(31, 100, 255, 0.1)',
          '20': 'rgba(31, 100, 255, 0.2)',
          '30': 'rgba(31, 100, 255, 0.3)',
          '40': 'rgba(31, 100, 255, 0.4)',
          '50': 'rgba(31, 100, 255, 0.5)',
          '60': 'rgba(31, 100, 255, 0.6)',
          '70': 'rgba(31, 100, 255, 0.7)',
          '80': 'rgba(31, 100, 255, 0.8)',
        },
        neutral: {
          '100': '#f9f9f9',
          '200': '#e7ecee',
          '300': '#c6ced2',
          '400': '#a0adb4',
          '500': '#83939c',
          '600': '#667a85',
          '700': '#4e616b',
          '800': '#3a4951',
          '900': '#283237',
          '1000': '#171c1f',
        },
      },
      'psychedelic-purple': {
        '100': '#f2e9ff',
        '200': '#f9d8ff',
        '300': '#f3aeff',
        '400': '#ec81ff',
        '500': '#e447ff',
        '600': '#c900ec',
        '700': '#a100bd',
        '800': '#7b0090',
        '900': '#570066',
        '1000': '#35003f',
      },
    },
    radii: {
      brand: {
        default: '1rem',
      },
      'radius-0': 0,
      'radius-050': '0.25rem',
      'radius-100': '0.5rem',
      'radius-150': '0.75rem',
      'radius-200': '1rem',
      'radius-300': '1.5rem',
      'radius-400': '2rem',
      'radius-500': '2.5rem',
      'radius-600': '3rem',
      'radius-800': '4rem',
      'radius-1000': '5rem',
      'radius-rounded': 1000,
    },
    space: {
      'space-0': '0rem',
      'space-050': '0.25rem',
      'space-100': '0.5rem',
      'space-150': '0.75rem',
      'space-200': '1rem',
      'space-300': '1.5rem',
      'space-400': '2rem',
      'space-500': '2.5rem',
      'space-600': '3rem',
      'space-800': '4rem',
      'space-1000': '5rem',
      'space-700': '3.5rem',
      'space-900': '4.5rem',
      'space-1100': '5.5rem',
      'space-1200': '6rem',
      'space-250': '1.25rem',
    },
    borders: {
      'border-xs': 0.5,
      'border-s': 1,
      'border-m': 2,
      'border-l': 3,
      'border-xl': 4,
    },
    shadows: {
      'shadow-negative-y': {
        'shadow-color': 'rgba(0, 0, 0, 0.03)',
        x: 0,
        y: 0,
        blur: 14,
        spread: 0,
        color: 'rgba(0, 0, 0, 0.03)',
      },
      'shadow-xs': {
        color: 'rgba(49, 31, 255, 0.03)',
        x: 0,
        y: 2,
        blur: 35,
        spread: 0,
      },
      'shadow-s-1': {
        color: 'rgba(0, 0, 0, 0.04)',
        x: 0,
        y: 1,
        blur: 2,
        spread: 0,
      },
      'shadow-s-2': {
        color: 'rgba(0, 0, 0, 0.08)',
        x: 0,
        y: 1,
        blur: 3,
        spread: 0,
      },
      'shadow-m-1': {
        color: 'rgba(0, 0, 0, 0.08)',
        x: 0,
        y: 4,
        blur: 6,
        spread: -1,
      },
      'shadow-m-2': {
        color: 'rgba(0, 0, 0, 0.08)',
        x: 0,
        y: 2,
        blur: 4,
        spread: -1,
      },
      'shadow-l-1': {
        x: 0,
        y: 8,
        blur: 12,
        spread: -2,
        color: 'rgba(0, 0, 0, 0.08)',
      },
      'shadow-l-2': {
        x: 0,
        y: 2,
        blur: 6,
        spread: -2,
        color: 'rgba(0, 0, 0, 0.06)',
      },
      'shadow-xl-1': {
        x: 0,
        y: 16,
        blur: 24,
        spread: -4,
        color: 'rgba(0, 0, 0, 0.08)',
      },
      'shadow-xl-2': {
        x: '0rem',
        y: '0.25rem',
        blur: '0.5rem',
        spread: '-0.125rem',
      },
      'shadow-xxl-1': {
        x: 0,
        y: 24,
        blur: 40,
        spread: -4,
        color: 'rgba(0, 0, 0, 0.08)',
      },
      'shadow-xxl-2': {
        x: 0,
        y: 0,
        blur: 16,
        spread: -2,
        color: 'rgba(0, 0, 0, 0.16)',
      },
      'shadow-left-side-table': {
        x: '-0.1875rem',
        y: '0rem',
        blur: '1rem',
        spread: '0rem',
      },
      'shadow-right-side-table': {
        x: '1rem',
        y: '1rem',
        blur: '1.5rem',
        spread: '-0.25rem',
      },
    },
    lineHeights: {
      display: {
        lg: '7rem',
        md: '4rem',
        sm: '3rem',
      },
      header: {
        lg: '2.5rem',
        md: '2.5rem',
        sm: '2rem',
      },
      label: {
        lg: '2rem',
        md: '1.5rem',
        sm: '1.5rem',
      },
      text: {
        lg: '2rem',
        md: '1.5rem',
        sm: '1.5rem',
      },
    },
    fontSizes: {
      display: {
        lg: '6rem',
        md: '3.25rem',
        sm: '2.25rem',
      },
      header: {
        lg: '1.75rem',
        md: '1.5rem',
        sm: '1.125rem',
      },
      label: {
        lg: '1rem',
        md: '0.875rem',
        sm: '0.75rem',
      },
      text: {
        lg: '1rem',
        md: '0.875rem',
        sm: '0.75rem',
      },
    },
    fontWeights: {
      display: {
        lg: 500,
        md: 400,
        sm: 700,
      },
      header: {
        lg: 700,
        md: 700,
        sm: 600,
      },
      label: {
        lg: 700,
        md: 600,
        sm: 600,
      },
      text: {
        lg: 400,
        md: 400,
        sm: 400,
      },
    },
    sizes: {
      'space-0': '0rem',
      'space-050': '0.25rem',
      'space-100': '0.5rem',
      'space-150': '0.75rem',
      'space-200': '1rem',
      'space-300': '1.5rem',
      'space-400': '2rem',
      'space-500': '2.5rem',
      'space-600': '3rem',
      'space-800': '4rem',
      'space-1000': '5rem',
      'space-700': '3.5rem',
      'space-900': '4.5rem',
      'space-1100': '5.5rem',
      'space-1200': '6rem',
      'space-250': '1.25rem',
    },
  },
  components: {
    buttons: {
      primary: {
        'background-default': 'blue-spark.600',
        'background-hover': 'blue-spark.500',
        'background-pressed': 'blue-spark.800',
        'background-focus': 'blue-spark.500',
        'background-disabled': 'trail-print.200',
        'text-default': 'white.100',
        'icon-default': 'white.100',
        'icon-disabled': 'obsidian.400',
        'stroke-focus': 'blue-spark.300',
        'text-disabled': 'obsidian.500',
      },
      secondary: {
        'background-default': 'obsidian.200',
        'background-hover': 'obsidian.300',
        'background-pressed': 'obsidian.300',
        'background-focus': 'obsidian.200',
        'background-disabled': 'trail-print.200',
        'text-default': 'obsidian.1000',
        'text-disabled': 'obsidian.500',
        'icon-default': 'obsidian.800',
        'icon-disabled': 'obsidian.400',
        'stroke-focus': 'obsidian.300',
      },
      danger: {
        'background-default': 'electric-crimson.600',
        'background-hover': 'electric-crimson.500',
        'background-pressed': 'electric-crimson.800',
        'background-focus': 'electric-crimson.500',
        'background-disabled': 'trail-print.200',
        'text-default': 'white.100',
        'text-disabled': 'obsidian.500',
        'icon-default': 'white.70',
        'icon-disabled': 'obsidian.400',
        'stroke-focus': 'electric-crimson.300',
      },
      'danger-secondary': {
        'background-default': 'electric-crimson.200',
        'background-hover': 'electric-crimson.100',
        'background-pressed': 'electric-crimson.400',
        'background-focus': 'electric-crimson.100',
        'background-disabled': 'trail-print.200',
        'text-default': 'electric-crimson.700',
        'text-disabled': 'obsidian.500',
        'icon-default': 'electric-crimson.500',
        'icon-disabled': 'obsidian.400',
        'stroke-focus': 'electric-crimson.300',
      },
      tertiary: {
        'background-default': 'blue-spark.100',
        'background-hover': 'blue-spark.200',
        'background-pressed': 'blue-spark.300',
        'background-focus': 'blue-spark.100',
        'background-disabled': 'trail-print.200',
        'text-default': 'blue-spark.700',
        'text-disabled': 'obsidian.500',
        'icon-default': 'blue-spark.700',
        'icon-disabled': 'obsidian.400',
        'stroke-focus': 'blue-spark.300',
        'stroke-default': 'white.0',
        'stroke-hover': 'white.0',
        'stroke-pressed': 'white.0',
      },
      'button-link': {
        default: {
          'text-default': 'blue-spark.500',
          'text-disabled': 'obsidian.500',
          'icon-default': 'white.100',
          'icon-disabled': 'obsidian.400',
          'text-hover': 'blue-spark.600',
          'text-pressed': 'blue-spark.800',
          'text-focused': 'blue-spark.500',
        },
        danger: {
          'text-default': 'electric-crimson.600',
          'text-disabled': 'obsidian.500',
          'icon-disabled': 'obsidian.400',
          'text-pressed': 'electric-crimson.800',
          'text-hover': 'electric-crimson.500',
          'text-focused': 'electric-crimson.600',
        },
        warning: {
          'text-default': 'lucky-orange.700',
          'text-disabled': 'obsidian.500',
          'icon-default': 'white.100',
          'icon-disabled': 'obsidian.400',
          'text-hover': 'golden-stone.800',
          'text-pressed': 'golden-stone.900',
          'text-focused': 'lucky-orange.700',
        },
      },
      'icon-button': {
        'background-hover': 'white.0',
        'background-pressed': 'blue-spark.100',
        'background-focus': 'white.0',
        'background-disabled': 'white.0',
        'text-default': 'white.100',
        'text-disabled': 'obsidian.500',
        'icon-default': 'purple-sea.1000',
        'icon-disabled': 'obsidian.400',
        'stroke-focus': 'blue-sari.200',
        'icon-hover': 'blue-spark.600',
      },
      subtle: {
        'background-default': 'white.0',
        'background-hover': 'blue-spark.100',
        'background-pressed': 'blue-spark.200',
        'background-focus': 'white.0',
        'background-disabled': 'white.0',
        'text-default': 'purple-sea.800',
        'text-disabled': 'obsidian.500',
        'icon-default': 'obsidian.700',
        'icon-disabled': 'obsidian.400',
        'stroke-focus': 'obsidian.300',
        'text-hover': 'blue-spark.700',
        'text-pressed': 'blue-spark.700',
        'stroke-default': 'white.0',
        'stroke-hover': 'white.0',
      },
      outline: {
        'background-default': 'white.100',
        'background-hover': 'blue-spark.100',
        'background-pressed': 'blue-spark.200',
        'background-focus': 'white.0',
        'background-disabled': 'trail-print.200',
        'text-default': 'purple-sea.800',
        'text-disabled': 'obsidian.500',
        'icon-default': 'obsidian.700',
        'text-hover': 'blue-spark.700',
        'text-pressed': 'blue-spark.700',
        'icon-disabled': 'obsidian.400',
        'stroke-focus': 'obsidian.300',
        'stroke-default': 'white.0',
        'stroke-hover': 'white.0',
      },
      'icon-button-secondary': {
        'background-hover': 'white.0',
        'background-pressed': 'blue-spark.100',
        'background-focus': 'white.0',
        'background-disabled': 'white.0',
        'text-default': 'white.100',
        'text-disabled': 'obsidian.500',
        'icon-default': 'purple-sea.1000',
        'icon-disabled': 'obsidian.400',
        'stroke-focus': 'blue-sari.200',
        'icon-hover': 'blue-spark.600',
        'background-primary': 'white.100',
      },
      'icon-button-primary': {
        'background-hover': 'white.100',
        'background-pressed': 'blue-spark.100',
        'background-focus': 'white.0',
        'background-disabled': 'white.0',
        'text-default': 'white.100',
        'text-disabled': 'obsidian.500',
        'icon-default': 'purple-sea.1000',
        'icon-disabled': 'obsidian.400',
        'stroke-focus': 'blue-sari.200',
        'icon-hover': 'blue-spark.600',
        'background-primary': 'white.100',
      },
      'height-lg': 'space-600',
      'height-md': 'space-500',
      'height-sm': 'space-400',
      'height-xs': 'space-300',
      'padding-lg': 'space-250',
      'padding-md': 'space-200',
      'padding-sm': 'space-150',
      'padding-xs': 'space-100',
      'link-padding': 'space-0',
      'icon-leading': 'space-200',
      'icon-trailing': 'space-200',
      'gutter-md': 'space-050',
      'gutter-sm': 'space-050',
      'gutter-xs': 'space-0',
      'gutter-lg': 'space-100',
      lg: 'radius-rounded',
      md: 'radius-rounded',
      sm: 'radius-rounded',
      xs: 'radius-rounded',
    },
    toggles: {
      'background-selected': 'blue-spark.600',
      'background-hover': 'blue-spark.500',
      'background-focus': 'blue-spark.500',
      'background-disabled': 'trail-print.200',
      'icon-on': 'white.100',
      'icon-disabled': 'obsidian.400',
      'stroke-focus': 'blue-spark.300',
      'background-unselected': 'black.20',
      'stroke-default': 'blue-sari.400',
      'icon-off': 'white.100',
    },
    'form-control': {
      'background-default': 'white.100',
      'background-hover': 'purple-sea.100',
      'background-pressed': 'white.100',
      'background-focus': 'white.100',
      'background-disabled': 'trail-print.200',
      'text-default': 'purple-sea.1000',
      'text-disabled': 'obsidian.500',
      'icon-default': 'purple-sea.800',
      'icon-disabled': 'obsidian.400',
      'stroke-focus': 'blue-spark.600',
      'stroke-default': 'blue-sari.200',
      'stroke-disabled': 'obsidian.300',
      'stroke-pressed': 'blue-sari.400',
      'text-placeholder': 'obsidian.500',
      'text-secondary': 'purple-sea.800',
      'stroke-hover': 'blue-sari.400',
      'stroke-error': 'electric-crimson.300',
      'text-error': 'electric-crimson.800',
      'icon-error': 'electric-crimson.800',
      'padding-below-label': 'space-050',
      'padding-side': 'space-050',
      'padding-top-bottom': 'space-100',
      'padding-top-bottom-sm': 'space-0',
      radius: 'space-150',
      'radius-sm': 'space-100',
    },
    'table-row': {
      'background-default': 'white.100',
      'background-hover': 'purple-sea.100',
      'background-disabled': 'trail-print.200',
      'stroke-default': 'blue-sari.200',
      'stroke-active': 'blue-spark.500',
      'cell-hover': 'purple-sea.200',
      'background-active': 'brand.primary-alpha.5',
      'background-error': 'electric-crimson.100',
    },
    tags: {
      low: {
        'background-default': 'blue-spark.100',
        'text-default': 'blue-spark.700',
        'icon-default': 'blue-spark.700',
        'stroke-default': 'blue-spark.200',
      },
      medium: {
        'background-default': 'golden-stone.200',
        'icon-default': 'golden-stone.900',
        'text-default': 'golden-stone.900',
        'stroke-default': 'golden-stone.300',
      },
      high: {
        'background-default': 'electric-indigo.100',
        'text-default': 'electric-indigo.800',
        'icon-default': 'electric-indigo.800',
        'stroke-default': 'electric-indigo.200',
      },
      default: {
        'background-default': 'white.100',
        stroke: 'blue-sari.200',
        'text-default': 'purple-sea.1000',
        'icon-default': 'purple-sea.800',
      },
      critical: {
        'background-default': 'electric-crimson.200',
        'text-default': 'electric-crimson.800',
        'icon-default': 'electric-crimson.800',
        'stroke-default': 'electric-crimson.300',
      },
      'height-lg': 'space-600',
      'height-md': 'space-500',
      'height-sm': 'space-400',
      'padding-lg': 'space-250',
      'padding-md': 'space-200',
      'padding-sm': 'space-150',
      'padding-between': 'space-100',
      'height-xs': 'space-300',
      'padding-xs': 'space-100',
      'height-xxs': 'space-200',
      'padding-xxs': 'space-050',
      lg: 'space-200',
      md: 'space-150',
      sm: 'space-100',
      xs: 'space-100',
      xxs: 'space-050',
    },
    chips: {
      'background-default': 'white.100',
      'background-hover': 'white.100',
      'background-pressed': 'obsidian.100',
      'background-focus': 'obsidian.100',
      'background-disabled': 'trail-print.200',
      'text-default': 'purple-sea.1000',
      'text-disabled': 'obsidian.500',
      'icon-default': 'purple-sea.800',
      'icon-disabled': 'obsidian.400',
      'stroke-hover': 'blue-sari.200',
    },
    nav: {
      'background-selected': 'trail-print.100',
      'text-default': 'purple-sea.1000',
      'text-active': 'blue-spark.700',
      'text-selected-2ndlevel': 'purple-sea.1000',
      'icon-default': 'purple-sea.1000',
      'background-hover': 'black.5',
      'icon-active': 'blue-spark.700',
      stroke: 'blue-sari.200',
      'background-pressed': 'black.10',
      background: 'obsidian.100',
      item: 'space-100',
      'item-collapsed': 'radius-rounded',
    },
    pagination: {
      'background-default': 'white.0',
      'background-hover': 'blue-spark.100',
      'background-pressed': 'blue-spark.200',
      'background-focus': 'white.0',
      'background-disabled': 'trail-print.200',
      'text-default': 'obsidian.600',
      'text-disabled': 'obsidian.500',
      'icon-default': 'obsidian.700',
      'text-hover': 'blue-spark.700',
      'text-pressed': 'blue-spark.700',
      'icon-disabled': 'obsidian.400',
      'stroke-focus': 'obsidian.300',
      'background-active': 'obsidian.100',
      'text-active': 'purple-sea.1000',
    },
    filters: {
      default: {
        'background-default': 'white.100',
        'background-hover': 'blue-spark.100',
        'background-pressed': 'blue-spark.200',
        'background-focus': 'white.100',
        'background-disabled': 'trail-print.200',
        'text-default': 'purple-sea.1000',
        'text-disabled': 'obsidian.500',
        'icon-default': 'purple-sea.800',
        'icon-disabled': 'obsidian.400',
        'stroke-default': 'white.0',
        'text-emphasized': 'blue-spark.700',
        'stroke-focus': 'blue-sari.300',
        'stroke-hover': 'white.0',
      },
      emphasized: {
        'background-default': 'blue-spark.700',
        'background-hover': 'blue-spark.500',
        'background-pressed': 'blue-spark.800',
        'background-focus': 'blue-spark.700',
        'background-disabled': 'trail-print.200',
        'text-default': 'white.100',
        'text-emphasized': 'white.100',
        'text-disabled': 'obsidian.500',
        'icon-default': 'white.100',
        'icon-disabled': 'obsidian.400',
        'stroke-default': 'blue-spark.500',
        'stroke-focus': 'blue-spark.300',
        'stroke-disabled': 'obsidian.300',
        'stroke-pressed': 'blue-spark.700',
        'stroke-hover': 'blue-spark.400',
      },
      'height-lg': 'space-600',
      'height-md': 'space-500',
      'height-sm': 'space-400',
      'height-xs': 'space-300',
      'padding-lg': 'space-200',
      'padding-md': 'space-150',
      'padding-sm': 'space-100',
      'padding-xs': 'space-050',
      radius: 'space-150',
    },
    'context-menu': {
      'background-default': 'white.100',
      'background-hover': 'purple-sea.100',
      'background-disabled': 'white.0',
      'text-default': 'purple-sea.1000',
      'text-secondary': 'purple-sea.800',
      'text-disabled': 'obsidian.500',
      'icon-default': 'purple-sea.800',
      'icon-disabled': 'obsidian.400',
      'stroke-default': 'blue-sari.200',
      'stroke-disabled': 'obsidian.300',
      'background-selected': 'blue-spark.100',
      'background-pressed': 'purple-sea.200',
      'text-active': 'blue-spark.700',
      'padding-top-bottom': 'space-100',
      gutter: 'space-100',
      'padding-left-right': 'space-050',
      'row-height': 'space-700',
      item: 'space-200',
    },
    tabs: {
      background: 'purple-sea.100',
      stroke: 'white.0',
      'text-default': 'blue-sari.700',
      'text-active': 'purple-sea.800',
      'background-active': 'white.100',
      'text-hover': 'purple-sea.1000',
      'height-lg': 'space-600',
      'height-md': 'space-500',
      'height-sm': 'space-400',
      'height-xs': 'space-300',
      'padding-lg': 'space-250',
      'padding-md': 'space-200',
      'padding-sm': 'space-150',
      'padding-xs': 'space-100',
      'icon-leading': 'space-200',
      'icon-trailing': 'space-200',
      lg: 'radius-rounded',
      md: 'radius-rounded',
      sm: 'radius-rounded',
      xs: 'radius-rounded',
    },
    'radio-button-group': {
      'background-default': 'white.100',
      'background-hover': 'black.5',
      'background-pressed': 'obsidian.200',
      'background-focus': 'blue-spark.500',
      'background-disabled': 'trail-print.200',
      'text-default': 'purple-sea.800',
      'text-disabled': 'obsidian.500',
      'icon-default': 'purple-sea.800',
      'icon-disabled': 'obsidian.400',
      'stroke-default': 'blue-sari.200',
      'stroke-focus': 'blue-sari.400',
    },
    charts: {
      medium: {
        'pie-chart': {
          '1': 'golden-stone.600',
          '2': 'golden-stone.400',
          '3': 'golden-stone.300',
          '4': 'golden-stone.200',
          default: 'golden-stone.400',
          hover: 'golden-stone.200',
        },
        gradient: {
          '1': 'golden-stone.200',
          '2': 'golden-stone.400',
        },
      },
      critical: {
        'pie-chart': {
          '1': 'electric-crimson.800',
          '2': 'electric-crimson.600',
          '3': 'electric-crimson.400',
          '4': 'electric-crimson.300',
          default: 'electric-crimson.600',
          hover: 'electric-crimson.400',
        },
        gradient: {
          '1': 'electric-crimson.300',
          '2': 'electric-crimson.500',
        },
      },
      awaiting: 'purple-sea.800',
      success: 'blue-spark.500',
      failed: 'electric-crimson.600',
      'in-progress': 'electric-indigo.700',
      high: {
        gradient: {
          '1': 'electric-indigo.700',
          '2': 'electric-indigo.400',
        },
        'pie-chart': {
          default: 'electric-indigo.700',
        },
      },
      low: {
        'gradient-line': {
          '1': 'blue-spark.500',
          '2': 'blue-spark.100',
        },
        'gradient-fill': {
          '1': 'blue-spark.300',
          '2': 'brand.primary-alpha.0',
        },
        default: 'blue-spark.500',
      },
      neutral: {
        default: 'obsidian.200',
      },
      'success-hover': 'blue-spark.400',
      'failed-hover': 'electric-crimson.400',
      'in-progress-hover': 'electric-indigo.500',
    },
    alerts: {
      info: {
        'background-default': 'purple-sea.900',
        'text-default': 'white.100',
        'icon-default': 'white.100',
      },
      success: {
        'background-default': 'green-bell-pepper.100',
        'text-default': 'green-bell-pepper.800',
        'icon-default': 'green-bell-pepper.800',
      },
      warning: {
        'background-default': 'golden-stone.100',
        'text-default': 'lucky-orange.700',
        'icon-default': 'lucky-orange.800',
      },
      error: {
        'background-default': 'electric-crimson.100',
        'text-default': 'electric-crimson.800',
        'icon-default': 'electric-crimson.800',
      },
      light: {
        'background-default': 'obsidian.100',
        'text-default': 'purple-sea.800',
        'icon-default': 'purple-sea.800',
      },
    },
    'full-page-modal': {
      background: 'obsidian.100',
    },
    'number-badge': {
      default: {
        'background-default': 'white.0',
        'text-default': 'purple-sea.1000',
        'icon-default': 'purple-sea.1000',
      },
      emphasized: {
        'background-default': 'purple-sea.100',
        'text-default': 'purple-sea.1000',
        'icon-default': 'purple-sea.1000',
      },
    },
    statuses: {
      active: {
        'background-default': 'white.0',
        'text-default': 'green-bell-pepper.800',
        stroke: 'blue-sari.200',
        'icon-default': 'green-bell-pepper.800',
      },
      complete: {
        'background-default': 'white.0',
        'text-default': 'blue-spark.700',
        stroke: 'blue-sari.200',
        'icon-default': 'blue-spark.700',
      },
      awaiting: {
        'background-default': 'white.0',
        'text-default': 'purple-sea.1000',
        stroke: 'blue-sari.200',
        'icon-default': 'purple-sea.800',
      },
      danger: {
        'background-default': 'white.0',
        'text-default': 'electric-crimson.800',
        stroke: 'blue-sari.200',
        'icon-default': 'electric-crimson.800',
      },
      pending: {
        'background-default': 'white.0',
        'text-default': 'electric-indigo.800',
        stroke: 'blue-sari.200',
        'icon-default': 'electric-indigo.700',
      },
      lg: 'radius-rounded',
      md: 'radius-rounded',
      sm: 'radius-rounded',
      xs: 'radius-rounded',
      xxs: 'radius-rounded',
    },
    popover: {
      'background-default': 'white.100',
      'background-disabled': 'white.0',
      'background-selected': 'blue-spark.100',
      'text-default': 'purple-sea.1000',
      'text-secondary': 'purple-sea.800',
      'text-disabled': 'obsidian.500',
      'icon-default': 'purple-sea.800',
      'icon-disabled': 'obsidian.400',
      'stroke-default': 'blue-sari.200',
      'stroke-disabled': 'obsidian.300',
      radius: 'space-200',
    },
    node: {
      'background-hover': 'obsidian.100',
      stroke: 'white.0',
      background: 'white.100',
      'stroke-2': 'white.0',
    },
    graph: {
      connectors: 'purple-sea.400',
      background: 'purple-sea.200',
    },
    cards: {
      'background-default': 'white.100',
      'background-hover': 'white.100',
      'background-pressed': 'obsidian.100',
      'background-focus': 'obsidian.100',
      'stroke-default': 'blue-sari.200',
    },
    'date-picker': {
      'background-default': 'white.100',
      'background-hover': 'obsidian.100',
      'background-selected': 'blue-spark.500',
      'text-default': 'purple-sea.1000',
      'text-active': 'blue-spark.700',
      'text-secondary': 'purple-sea.800',
      'text-disabled': 'obsidian.500',
      'icon-default': 'purple-sea.800',
      'icon-disabled': 'obsidian.400',
      'stroke-default': 'blue-sari.200',
      'stroke-disabled': 'obsidian.300',
      'padding-top-bottom': 'space-300',
      'padding-left-right': 'space-300',
      gutter: 'space-150',
      'date-size': 'space-500',
    },
    widgets: {
      background: 'white.100',
      stroke: 'blue-sari.200',
      'side-padding': 'space-300',
      'top-bottom-padding': 'space-300',
      radius: 'space-200',
    },
    'tabs-underline': {
      stroke: 'blue-sari.200',
      'text-default': 'blue-sari.700',
      'text-active': 'blue-spark.700',
      'text-hover': 'purple-sea.1000',
      'background-hover': 'white.0',
    },
    components: {
      buttons: {
        primary: {
          'background-default': 'blue-spark.600',
          'background-hover': 'blue-spark.500',
          'background-pressed': 'blue-spark.800',
          'background-focus': 'blue-spark.500',
          'background-disabled': 'trail-print.200',
          'text-default': 'white.100',
          'icon-default': 'white.100',
          'icon-disabled': 'obsidian.400',
          'stroke-focus': 'blue-spark.300',
          'text-disabled': 'obsidian.500',
        },
        secondary: {
          'background-default': 'obsidian.200',
          'background-hover': 'obsidian.300',
          'background-pressed': 'obsidian.300',
          'background-focus': 'obsidian.200',
          'background-disabled': 'trail-print.200',
          'text-default': 'obsidian.1000',
          'text-disabled': 'obsidian.500',
          'icon-default': 'obsidian.800',
          'icon-disabled': 'obsidian.400',
          'stroke-focus': 'obsidian.300',
        },
        danger: {
          'background-default': 'electric-crimson.600',
          'background-hover': 'electric-crimson.500',
          'background-pressed': 'electric-crimson.800',
          'background-focus': 'electric-crimson.500',
          'background-disabled': 'trail-print.200',
          'text-default': 'white.100',
          'text-disabled': 'obsidian.500',
          'icon-default': 'white.70',
          'icon-disabled': 'obsidian.400',
          'stroke-focus': 'electric-crimson.300',
        },
        'danger-secondary': {
          'background-default': 'electric-crimson.200',
          'background-hover': 'electric-crimson.100',
          'background-pressed': 'electric-crimson.400',
          'background-focus': 'electric-crimson.100',
          'background-disabled': 'trail-print.200',
          'text-default': 'electric-crimson.700',
          'text-disabled': 'obsidian.500',
          'icon-default': 'electric-crimson.500',
          'icon-disabled': 'obsidian.400',
          'stroke-focus': 'electric-crimson.300',
        },
        tertiary: {
          'background-default': 'blue-spark.100',
          'background-hover': 'blue-spark.200',
          'background-pressed': 'blue-spark.300',
          'background-focus': 'blue-spark.100',
          'background-disabled': 'trail-print.200',
          'text-default': 'blue-spark.700',
          'text-disabled': 'obsidian.500',
          'icon-default': 'blue-spark.700',
          'icon-disabled': 'obsidian.400',
          'stroke-focus': 'blue-spark.300',
          'stroke-default': 'white.0',
          'stroke-hover': 'white.0',
          'stroke-pressed': 'white.0',
        },
        'button-link': {
          default: {
            'text-default': 'blue-spark.500',
            'text-disabled': 'obsidian.500',
            'icon-default': 'white.100',
            'icon-disabled': 'obsidian.400',
            'text-hover': 'blue-spark.600',
            'text-pressed': 'blue-spark.800',
            'text-focused': 'blue-spark.500',
          },
          danger: {
            'text-default': 'electric-crimson.600',
            'text-disabled': 'obsidian.500',
            'icon-disabled': 'obsidian.400',
            'text-pressed': 'electric-crimson.800',
            'text-hover': 'electric-crimson.500',
            'text-focused': 'electric-crimson.600',
          },
          warning: {
            'text-default': 'lucky-orange.700',
            'text-disabled': 'obsidian.500',
            'icon-default': 'white.100',
            'icon-disabled': 'obsidian.400',
            'text-hover': 'golden-stone.800',
            'text-pressed': 'golden-stone.900',
            'text-focused': 'lucky-orange.700',
          },
        },
        'icon-button': {
          'background-hover': 'white.0',
          'background-pressed': 'blue-spark.100',
          'background-focus': 'white.0',
          'background-disabled': 'white.0',
          'text-default': 'white.100',
          'text-disabled': 'obsidian.500',
          'icon-default': 'purple-sea.1000',
          'icon-disabled': 'obsidian.400',
          'stroke-focus': 'blue-sari.200',
          'icon-hover': 'blue-spark.600',
        },
        subtle: {
          'background-default': 'white.0',
          'background-hover': 'blue-spark.100',
          'background-pressed': 'blue-spark.200',
          'background-focus': 'white.0',
          'background-disabled': 'white.0',
          'text-default': 'purple-sea.800',
          'text-disabled': 'obsidian.500',
          'icon-default': 'obsidian.700',
          'icon-disabled': 'obsidian.400',
          'stroke-focus': 'obsidian.300',
          'text-hover': 'blue-spark.700',
          'text-pressed': 'blue-spark.700',
          'stroke-default': 'white.0',
          'stroke-hover': 'white.0',
        },
        outline: {
          'background-default': 'white.100',
          'background-hover': 'blue-spark.100',
          'background-pressed': 'blue-spark.200',
          'background-focus': 'white.0',
          'background-disabled': 'trail-print.200',
          'text-default': 'purple-sea.800',
          'text-disabled': 'obsidian.500',
          'icon-default': 'obsidian.700',
          'text-hover': 'blue-spark.700',
          'text-pressed': 'blue-spark.700',
          'icon-disabled': 'obsidian.400',
          'stroke-focus': 'obsidian.300',
          'stroke-default': 'white.0',
          'stroke-hover': 'white.0',
        },
        'icon-button-secondary': {
          'background-hover': 'white.0',
          'background-pressed': 'blue-spark.100',
          'background-focus': 'white.0',
          'background-disabled': 'white.0',
          'text-default': 'white.100',
          'text-disabled': 'obsidian.500',
          'icon-default': 'purple-sea.1000',
          'icon-disabled': 'obsidian.400',
          'stroke-focus': 'blue-sari.200',
          'icon-hover': 'blue-spark.600',
          'background-primary': 'white.100',
        },
        'icon-button-primary': {
          'background-hover': 'white.100',
          'background-pressed': 'blue-spark.100',
          'background-focus': 'white.0',
          'background-disabled': 'white.0',
          'text-default': 'white.100',
          'text-disabled': 'obsidian.500',
          'icon-default': 'purple-sea.1000',
          'icon-disabled': 'obsidian.400',
          'stroke-focus': 'blue-sari.200',
          'icon-hover': 'blue-spark.600',
          'background-primary': 'white.100',
        },
      },
      toggles: {
        'background-selected': 'blue-spark.600',
        'background-hover': 'blue-spark.500',
        'background-focus': 'blue-spark.500',
        'background-disabled': 'trail-print.200',
        'icon-on': 'white.100',
        'icon-disabled': 'obsidian.400',
        'stroke-focus': 'blue-spark.300',
        'background-unselected': 'black.20',
        'stroke-default': 'blue-sari.400',
        'icon-off': 'white.100',
      },
      'form-control': {
        'background-default': 'white.100',
        'background-hover': 'purple-sea.100',
        'background-pressed': 'white.100',
        'background-focus': 'white.100',
        'background-disabled': 'trail-print.200',
        'text-default': 'purple-sea.1000',
        'text-disabled': 'obsidian.500',
        'icon-default': 'purple-sea.800',
        'icon-disabled': 'obsidian.400',
        'stroke-focus': 'blue-spark.600',
        'stroke-default': 'blue-sari.200',
        'stroke-disabled': 'obsidian.300',
        'stroke-pressed': 'blue-sari.400',
        'text-placeholder': 'obsidian.500',
        'text-secondary': 'purple-sea.800',
        'stroke-hover': 'blue-sari.400',
        'stroke-error': 'electric-crimson.300',
        'text-error': 'electric-crimson.800',
        'icon-error': 'electric-crimson.800',
      },
      'table-row': {
        'background-default': 'white.100',
        'background-hover': 'purple-sea.100',
        'background-disabled': 'trail-print.200',
        'stroke-default': 'blue-sari.200',
        'stroke-active': 'blue-spark.500',
        'cell-hover': 'purple-sea.200',
        'background-active': 'brand.primary-alpha.5',
        'background-error': 'electric-crimson.100',
      },
      tags: {
        low: {
          'background-default': 'blue-spark.100',
          'text-default': 'blue-spark.700',
          'icon-default': 'blue-spark.700',
          'stroke-default': 'blue-spark.200',
        },
        medium: {
          'background-default': 'golden-stone.200',
          'icon-default': 'golden-stone.900',
          'text-default': 'golden-stone.900',
          'stroke-default': 'golden-stone.300',
        },
        high: {
          'background-default': 'electric-indigo.100',
          'text-default': 'electric-indigo.800',
          'icon-default': 'electric-indigo.800',
          'stroke-default': 'electric-indigo.200',
        },
        default: {
          'background-default': 'white.100',
          stroke: 'blue-sari.200',
          'text-default': 'purple-sea.1000',
          'icon-default': 'purple-sea.800',
        },
        critical: {
          'background-default': 'electric-crimson.200',
          'text-default': 'electric-crimson.800',
          'icon-default': 'electric-crimson.800',
          'stroke-default': 'electric-crimson.300',
        },
      },
      chips: {
        'background-default': 'white.100',
        'background-hover': 'white.100',
        'background-pressed': 'obsidian.100',
        'background-focus': 'obsidian.100',
        'background-disabled': 'trail-print.200',
        'text-default': 'purple-sea.1000',
        'text-disabled': 'obsidian.500',
        'icon-default': 'purple-sea.800',
        'icon-disabled': 'obsidian.400',
        'stroke-hover': 'blue-sari.200',
      },
      nav: {
        'background-selected': 'trail-print.100',
        'text-default': 'purple-sea.1000',
        'text-active': 'blue-spark.700',
        'text-selected-2ndlevel': 'purple-sea.1000',
        'icon-default': 'purple-sea.1000',
        'background-hover': 'black.5',
        'icon-active': 'blue-spark.700',
        stroke: 'blue-sari.200',
        'background-pressed': 'black.10',
        background: 'obsidian.100',
      },
      pagination: {
        'background-default': 'white.0',
        'background-hover': 'blue-spark.100',
        'background-pressed': 'blue-spark.200',
        'background-focus': 'white.0',
        'background-disabled': 'trail-print.200',
        'text-default': 'obsidian.600',
        'text-disabled': 'obsidian.500',
        'icon-default': 'obsidian.700',
        'text-hover': 'blue-spark.700',
        'text-pressed': 'blue-spark.700',
        'icon-disabled': 'obsidian.400',
        'stroke-focus': 'obsidian.300',
        'background-active': 'obsidian.100',
        'text-active': 'purple-sea.1000',
      },
      filters: {
        default: {
          'background-default': 'white.100',
          'background-hover': 'blue-spark.100',
          'background-pressed': 'blue-spark.200',
          'background-focus': 'white.100',
          'background-disabled': 'trail-print.200',
          'text-default': 'purple-sea.1000',
          'text-disabled': 'obsidian.500',
          'icon-default': 'purple-sea.800',
          'icon-disabled': 'obsidian.400',
          'stroke-default': 'white.0',
          'text-emphasized': 'blue-spark.700',
          'stroke-focus': 'blue-sari.300',
          'stroke-hover': 'white.0',
        },
        emphasized: {
          'background-default': 'blue-spark.700',
          'background-hover': 'blue-spark.500',
          'background-pressed': 'blue-spark.800',
          'background-focus': 'blue-spark.700',
          'background-disabled': 'trail-print.200',
          'text-default': 'white.100',
          'text-emphasized': 'white.100',
          'text-disabled': 'obsidian.500',
          'icon-default': 'white.100',
          'icon-disabled': 'obsidian.400',
          'stroke-default': 'blue-spark.500',
          'stroke-focus': 'blue-spark.300',
          'stroke-disabled': 'obsidian.300',
          'stroke-pressed': 'blue-spark.700',
          'stroke-hover': 'blue-spark.400',
        },
      },
      'context-menu': {
        'background-default': 'white.100',
        'background-hover': 'purple-sea.100',
        'background-disabled': 'white.0',
        'text-default': 'purple-sea.1000',
        'text-secondary': 'purple-sea.800',
        'text-disabled': 'obsidian.500',
        'icon-default': 'purple-sea.800',
        'icon-disabled': 'obsidian.400',
        'stroke-default': 'blue-sari.200',
        'stroke-disabled': 'obsidian.300',
        'background-selected': 'blue-spark.100',
        'background-pressed': 'purple-sea.200',
        'text-active': 'blue-spark.700',
      },
      tabs: {
        background: 'purple-sea.100',
        stroke: 'white.0',
        'text-default': 'blue-sari.700',
        'text-active': 'purple-sea.800',
        'background-active': 'white.100',
        'text-hover': 'purple-sea.1000',
      },
      'radio-button-group': {
        'background-default': 'white.100',
        'background-hover': 'black.5',
        'background-pressed': 'obsidian.200',
        'background-focus': 'blue-spark.500',
        'background-disabled': 'trail-print.200',
        'text-default': 'purple-sea.800',
        'text-disabled': 'obsidian.500',
        'icon-default': 'purple-sea.800',
        'icon-disabled': 'obsidian.400',
        'stroke-default': 'blue-sari.200',
        'stroke-focus': 'blue-sari.400',
      },
      charts: {
        medium: {
          'pie-chart': {
            '1': 'golden-stone.600',
            '2': 'golden-stone.400',
            '3': 'golden-stone.300',
            '4': 'golden-stone.200',
            default: 'golden-stone.400',
            hover: 'golden-stone.200',
          },
          gradient: {
            '1': 'golden-stone.200',
            '2': 'golden-stone.400',
          },
        },
        critical: {
          'pie-chart': {
            '1': 'electric-crimson.800',
            '2': 'electric-crimson.600',
            '3': 'electric-crimson.400',
            '4': 'electric-crimson.300',
            default: 'electric-crimson.600',
            hover: 'electric-crimson.400',
          },
          gradient: {
            '1': 'electric-crimson.300',
            '2': 'electric-crimson.500',
          },
        },
        awaiting: 'purple-sea.800',
        success: 'blue-spark.500',
        failed: 'electric-crimson.600',
        'in-progress': 'electric-indigo.700',
        high: {
          gradient: {
            '1': 'electric-indigo.700',
            '2': 'electric-indigo.400',
          },
          'pie-chart': {
            default: 'electric-indigo.700',
          },
        },
        low: {
          'gradient-line': {
            '1': 'blue-spark.500',
            '2': 'blue-spark.100',
          },
          'gradient-fill': {
            '1': 'blue-spark.300',
            '2': 'brand.primary-alpha.0',
          },
          default: 'blue-spark.500',
        },
        neutral: {
          default: 'obsidian.200',
        },
        'success-hover': 'blue-spark.400',
        'failed-hover': 'electric-crimson.400',
        'in-progress-hover': 'electric-indigo.500',
      },
      alerts: {
        info: {
          'background-default': 'purple-sea.900',
          'text-default': 'white.100',
          'icon-default': 'white.100',
        },
        success: {
          'background-default': 'green-bell-pepper.100',
          'text-default': 'green-bell-pepper.800',
          'icon-default': 'green-bell-pepper.800',
        },
        warning: {
          'background-default': 'golden-stone.100',
          'text-default': 'lucky-orange.700',
          'icon-default': 'lucky-orange.800',
        },
        error: {
          'background-default': 'electric-crimson.100',
          'text-default': 'electric-crimson.800',
          'icon-default': 'electric-crimson.800',
        },
        light: {
          'background-default': 'obsidian.100',
          'text-default': 'purple-sea.800',
          'icon-default': 'purple-sea.800',
        },
      },
      'full-page-modal': {
        background: 'obsidian.100',
      },
      'number-badge': {
        default: {
          'background-default': 'white.0',
          'text-default': 'purple-sea.1000',
          'icon-default': 'purple-sea.1000',
        },
        emphasized: {
          'background-default': 'purple-sea.100',
          'text-default': 'purple-sea.1000',
          'icon-default': 'purple-sea.1000',
        },
      },
      statuses: {
        active: {
          'background-default': 'white.0',
          'text-default': 'green-bell-pepper.800',
          stroke: 'blue-sari.200',
          'icon-default': 'green-bell-pepper.800',
        },
        complete: {
          'background-default': 'white.0',
          'text-default': 'blue-spark.700',
          stroke: 'blue-sari.200',
          'icon-default': 'blue-spark.700',
        },
        awaiting: {
          'background-default': 'white.0',
          'text-default': 'purple-sea.1000',
          stroke: 'blue-sari.200',
          'icon-default': 'purple-sea.800',
        },
        danger: {
          'background-default': 'white.0',
          'text-default': 'electric-crimson.800',
          stroke: 'blue-sari.200',
          'icon-default': 'electric-crimson.800',
        },
        pending: {
          'background-default': 'white.0',
          'text-default': 'electric-indigo.800',
          stroke: 'blue-sari.200',
          'icon-default': 'electric-indigo.700',
        },
      },
      popover: {
        'background-default': 'white.100',
        'background-disabled': 'white.0',
        'background-selected': 'blue-spark.100',
        'text-default': 'purple-sea.1000',
        'text-secondary': 'purple-sea.800',
        'text-disabled': 'obsidian.500',
        'icon-default': 'purple-sea.800',
        'icon-disabled': 'obsidian.400',
        'stroke-default': 'blue-sari.200',
        'stroke-disabled': 'obsidian.300',
      },
      node: {
        'background-hover': 'obsidian.100',
        stroke: 'white.0',
        background: 'white.100',
        'stroke-2': 'white.0',
      },
      graph: {
        connectors: 'purple-sea.400',
        background: 'purple-sea.200',
      },
      cards: {
        'background-default': 'white.100',
        'background-hover': 'white.100',
        'background-pressed': 'obsidian.100',
        'background-focus': 'obsidian.100',
        'stroke-default': 'blue-sari.200',
      },
      'date-picker': {
        'background-default': 'white.100',
        'background-hover': 'obsidian.100',
        'background-selected': 'blue-spark.500',
        'text-default': 'purple-sea.1000',
        'text-active': 'blue-spark.700',
        'text-secondary': 'purple-sea.800',
        'text-disabled': 'obsidian.500',
        'icon-default': 'purple-sea.800',
        'icon-disabled': 'obsidian.400',
        'stroke-default': 'blue-sari.200',
        'stroke-disabled': 'obsidian.300',
      },
      widgets: {
        background: 'white.100',
        stroke: 'blue-sari.200',
      },
      'tabs-underline': {
        stroke: 'blue-sari.200',
        'text-default': 'blue-sari.700',
        'text-active': 'blue-spark.700',
        'text-hover': 'purple-sea.1000',
        'background-hover': 'white.0',
      },
    },
    tables: {
      'row-height': 'space-700',
      'cell-padding': 'space-050',
      'header-height': 'space-400',
      'cell-padding-with-button-inside': 'space-150',
      radius: 'space-100',
    },
    alert: {
      padding: 'space-150',
      gutter: 'space-200',
    },
    'action-menu': {
      'padding-top-bottom': 'space-100',
      gutter: 'space-200',
      'padding-left-right': 'space-100',
      'row-height': 'space-700',
    },
    navigation: {
      'side-padding': 'space-200',
      'mobile-height': 'space-600',
      'side-padding-collapsed': 'space-100',
      'item-padding': 'space-100',
      'item-space-between': 'space-100',
      item: 'space-100',
      'item-collapsed': 'radius-rounded',
    },
    dialogs: {
      padding: 'space-400',
      'padding-above-buttons': 'space-500',
      'padding-between-inputs': 'space-300',
    },
    popovers: {
      padding: 'space-050',
    },
    badges: {
      'height-lg': 'space-400',
      'height-md': 'space-300',
      'height-sm': 'space-200',
      'height-xs': 'space-200',
      'padding-lg': 'space-050',
      'padding-md': 'space-050',
      'padding-sm': 'space-050',
      'padding-xs': 'space-050',
      'icon-leading': 'space-200',
      'icon-trailing': 'space-200',
    },
    'list-items&dropdowns': {
      'side-padding': 'space-100',
      'top-down-padding': 'space-150',
    },
    brand: {
      'top-bottom-padding': 'space-300',
    },
    sections: {
      'padding-side': 'space-250',
      'padding-top-bottom': 'space-200',
      'padding-side-clickable-content': 'space-200',
    },
    dialog: {
      dialog: 'space-200',
    },
    dropdown: {
      radius: 'space-200',
    },
  },
  semantic: {
    colors: {
      '1': 'blue-spark.500',
      '2': 'blue-spark.100',
      text: {
        primary: 'purple-sea.1000',
        secondary: 'purple-sea.800',
        tertiary: 'blue-sari.700',
        'brand-bold': 'blue-spark.700',
        state: {
          'success-bold': 'green-bell-pepper.800',
          'success-subtle': 'green-bell-pepper.100',
          'warning-bold': 'lucky-orange.700',
          'warning-subtle': 'golden-stone.100',
          'danger-bold': 'electric-crimson.800',
          'danger-subtle': 'electric-crimson.100',
          disabled: 'obsidian.500',
          'warning-bold-hover': 'lucky-orange.600',
        },
        'brand-subtle': 'blue-spark.200',
        'brand-medium': 'blue-spark.500',
        'primary-inverse': 'white.100',
        'secondary-inverse': 'obsidian.400',
        'tertiary-inverse': 'obsidian.600',
        'on-dark-background': 'white.100',
        'on-light-background': 'black.100',
      },
      background: {
        primary: 'white.100',
        secondary: 'obsidian.100',
        tertiary: 'obsidian.200',
        state: {
          'success-subtle': 'green-bell-pepper.100',
          'success-bold': 'green-bell-pepper.500',
          'warning-subtle': 'golden-stone.100',
          'warning-bold': 'lucky-orange.500',
          'danger-subtle': 'electric-crimson.100',
          'danger-bold': 'electric-crimson.600',
          disabled: 'trail-print.200',
          hover: 'black.5',
        },
        'brand-subtle': 'blue-spark.200',
        'brand-bold': 'blue-spark.700',
        'brand-medium': 'blue-spark.500',
        'primary-inverse': 'purple-sea.900',
        elevation: {
          'elevation-1': 'purple-sea.100',
          'elevation-2': 'purple-sea.200',
          'elevation-3': 'purple-sea.300',
        },
        glass: {
          '1': 'white.20',
          '2': 'white.60',
          '3': 'white.90',
          'primary-1': 'brand.primary-alpha.10',
          'primary-2': 'brand.primary-alpha.20',
          'primary-3': 'brand.primary-alpha.40',
        },
        'brand-extra-subtle': 'blue-spark.100',
        'brand-extra-bold': 'blue-spark.800',
        overlay: 'black.60',
        'skeleton-medium': 'obsidian.200',
      },
      stroke: {
        primary: 'blue-sari.200',
        secondary: 'blue-sari.300',
        tertiary: 'blue-sari.400',
        state: {
          'success-subtle': 'green-bell-pepper.300',
          'success-bold': 'green-bell-pepper.700',
          'warning-subtle': 'golden-stone.300',
          'warning-bold': 'lucky-orange.700',
          'danger-subtle': 'electric-crimson.300',
          'danger-bold': 'electric-crimson.700',
          hover: 'blue-spark.300',
          focused: 'blue-spark.600',
          pressed: 'blue-spark.800',
          disabled: 'obsidian.300',
        },
        'brand-subtle': 'blue-spark.300',
        'brand-medium': 'blue-spark.600',
        'brand-bold': 'blue-spark.800',
      },
      icon: {
        primary: 'purple-sea.1000',
        secondary: 'purple-sea.800',
        state: {
          'success-bold': 'green-bell-pepper.800',
          'success-subtle': 'green-bell-pepper.200',
          'warning-bold': 'lucky-orange.800',
          'warning-subtle': 'golden-stone.200',
          'danger-bold': 'electric-crimson.800',
          'danger-subtle': 'electric-crimson.200',
          disabled: 'obsidian.400',
        },
        'brand-bold': 'blue-spark.700',
        'brand-medium': 'blue-spark.500',
        'brand-subtle': 'blue-spark.200',
        'primary-inverse': 'white.100',
        'secondary-inverse': 'obsidian.300',
        'tertiary-inverse': 'obsidian.500',
        'on-light-background': 'black.100',
        'on-dark-background': 'white.100',
        border: 'blue-sari.200',
        background: 'white.100',
        stroke: 'blue-sari.200',
      },
      illustrations: {
        'shade-1': 'obsidian.400',
        'shade-2': 'obsidian.300',
        'shade-3': 'obsidian.200',
        'gradient-1': 'purple-sea.100',
        'gradient-2': 'purple-sea.200',
        'shade-4': 'obsidian.600',
      },
      'u-ar': {
        approve: {
          bg: 'electric-indigo.100',
          icon: 'electric-indigo.800',
        },
        deny: {
          '1': 'electric-crimson.600',
          '2': 'electric-crimson.400',
          bg: 'electric-crimson.100',
          icon: 'electric-crimson.800',
        },
        changed: {
          '1': 'lucky-orange.600',
          '2': 'lucky-orange.400',
          bg: 'golden-stone.100',
          icon: 'lucky-orange.800',
        },
      },
      issues: {
        high: {
          default: 'electric-indigo.700',
          medium: 'electric-indigo.400',
          subtle: 'electric-indigo.200',
          'very-subtle': 'electric-indigo.100',
          bold: 'electric-indigo.800',
        },
        low: {
          default: 'blue-spark.500',
          'very-subtle': 'blue-spark.100',
          bold: 'blue-spark.700',
          subtle: 'blue-spark.200',
        },
        critical: {
          default: 'electric-crimson.600',
          medium: 'electric-crimson.400',
          bold: 'electric-crimson.800',
          subtle: 'electric-crimson.300',
          'very-subtle': 'electric-crimson.200',
          strong: 'electric-crimson.500',
        },
        medium: {
          default: 'golden-stone.400',
          subtle: 'golden-stone.300',
          'very-subtle': 'golden-stone.200',
          medium: 'golden-stone.400',
          bold: 'golden-stone.900',
        },
      },
      feather: {
        'gradient-1': 'white.100',
        'gradient-2': 'white.0',
      },
      logo: {
        color: 'black.100',
      },
    },
    spacing: {
      margins: {
        side: 'space-200',
        bottom: 'space-300',
        top: 'space-200',
      },
      gutter: {
        md: 'space-400',
        xl: 'space-600',
        sm: 'space-200',
        xs: 'space-100',
        lg: 'space-400',
        'page-default-vertical': 'space-200',
        'component-default-vertical': 'space-200',
        'page-default-horizontal': 'space-200',
      },
    },
  },
} as const;
export const UI_PREFIX = 'linx';
export const BASE_FONT_SIZE = 16;
